
const DELETE_BEHAVIORS = [
  // { id: 0, name: "ClientSetNull" },
  // { id: 1, name: "Restrict" },
  // { id: 2, name: "SetNull" },
  { id: 3, name: "Cascade" },
  // { id: 4, name: "ClientCascade" },
  { id: 5, name: "NoAction" },
  // { id: 6, name: "ClientNoAction" },
];

const deleteBehaviorName = (item) => {
  if (item.deleteBehavior) return item.deleteBehavior;
  if (item.onDelete === null || item.onDelete === undefined) return null;
  const behavior = DELETE_BEHAVIORS.find((x) => x.id === item.onDelete);
  return behavior ? behavior.name : item.onDelete;
};

const branchOptions = (branches) =>
  (branches || []).map((item) => ({
    value: item.id,
    text: item.title || item.branchName || item.name || String(item.id),
  }));

export default {
  companies: (state) => {
    return state.companies;
  },
  company: (state) => {
    return state.company;
  },

  // Upload Getters ---------------------------------------------------------------
  uploadInfo: (state) => {
    return state.uploadInfo;
  },
  uploads: (state) => {
    return state.uploads;
  },

  // Dropdowns Getters ---------------------------------------------------------------
  subSystemOptions: (state) => {
    const subSystemOptions = [];
    state.subSystems.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      subSystemOptions.push(pushItem);
    }
    return subSystemOptions;
  },

  companyTypeOptions: (state) => {
    const companyTypeOptions = [];
    state.companyTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      companyTypeOptions.push(pushItem);
    }
    return companyTypeOptions;
  },
  // RelationField Getters ---------------------------------------------------------
  relationFields: (state) => {
    return (state.relationFields || []).map((item) => {
      return {
        ...item,
        parentDb: item.dbNameParent || item.parentDb,
        parentDbTitle: item.dbTitleParent || item.dbNameParent,
        parentSchema: item.tableSchemaParent || item.parentSchema,
        parentTable: item.tableNameParent || item.parentTable,
        childDb: item.dbNameChild || item.childDb,
        childDbTitle: item.dbTitleChild || item.dbNameChild,
        childSchema: item.tableSchemaChild || item.childSchema,
        childTable: item.tableNameChild || item.childTable,
        foreignKey: item.fk || item.foreignKey,
        deleteBehavior: deleteBehaviorName(item),
      };
    });
  },

  relationTableOptions: (state) =>
    state.relationTables.map(({ table }) => ({
      value: table,
      text: table,
    })),

  relationSchemaOptions: (state) =>
    state.relationTables.map(({ schema }) => ({
      value: schema,
      text: schema,
    })),

  relationForeignKeyOptions: (state) =>
    state.relationForeignKeys.map(({ column }) => ({
      value: column,
      text: column,
    })),

  relationParentTableOptions: (state) =>
    state.relationParentTables.map(({ table }) => ({
      value: table,
      text: table,
    })),

  relationChildTableOptions: (state) =>
    state.relationChildTables.map(({ table }) => ({
      value: table,
      text: table,
    })),

  relationParentForeignKeyOptions: (state) =>
    state.relationParentForeignKeys.map(({ column }) => ({
      value: column,
      text: column,
    })),

  databaseOptions: (state) =>
    state.databases.map(({ id, title }) => ({
      id: id,
      value: title,
      text: title,
    })),

  // Menu Getters ---------------------------------------------------------------
  menus: (state) => state.menus,
  clubPermissionOptions: (state) =>
    (state.clubPermissions || []).flatMap((group) => [
      { header: group.title },
      ...(group.permissions || []).map((item) => ({
        value: item.id,
        text: item.title,
        group: group.title,
      })),
    ]),

  // Backup Import / Export Getters -------------------------------------------
  companyOptions: (state) =>
    (state.companies || []).map((item) => ({
      value: item.id,
      text: item.code ? item.code + " - " + item.companyName : item.companyName,
    })),
  targetBranchOptions: (state) => branchOptions(state.targetBranches),
  sourceBranchOptions: (state) => branchOptions(state.sourceBranches),

  backupImport: (state) => state.backupImport,
  backupImportId: (state) => state.backupImportId,
  backupUploadProgress: (state) => state.backupUploadProgress,
  backupUploading: (state) => state.backupUploading,
  backupExporting: (state) => state.backupExporting,
  // نام شرکت کنار شعبه می‌آید تا شعبه‌های هم‌نامِ شرکت‌های مختلف از هم جدا باشند.
  exportBranchOptions: (state) =>
    (state.exportBranches || []).map((item) => {
      const company = (state.companies || []).find(
        (row) => row.id === item.companyId,
      );
      const name = item.branchName || item.title || String(item.id);
      const branch = item.code ? item.code + " - " + name : name;
      return {
        value: item.id,
        companyId: item.companyId,
        text: company ? branch + " (" + company.companyName + ")" : branch,
      };
    }),

  // Windows Backup Import Getters --------------------------------------------
  winTargetBranchOptions: (state) => branchOptions(state.winTargetBranches),
  winBackupImport: (state) => state.winBackupImport,
  winBackupUploadProgress: (state) => state.winBackupUploadProgress,
  winBackupUploading: (state) => state.winBackupUploading,

  // Static Getters ---------------------------------------------------------------
  deleteBehaviorOptions() {
    return DELETE_BEHAVIORS.map((item) => {
      return { value: item.name, text: item.name };
    });
  },

  fieldsPlanOptions() {
    return [
      { value: "A", text: "Plan A" },
      { value: "B", text: "Plan B" },
      { value: "C", text: "Plan C" },
      { value: "D", text: "Plan D" },
    ];
  },
};
